"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentSelectorModal = exports.DepartmentSelector = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var icons_1 = require("../../components/icon/icons");
var index_1 = require("../../components/icon/index");
var radio_input_1 = require("../../components/input/radio.input");
var radio_input_state_1 = require("../../components/input/radio.input.state");
var mithril_component_1 = require("../../components/mithril.component");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var theme_1 = require("../../components/theme");
var index_2 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var index_3 = require("../../services/index");
var department_selector_style_1 = require("./department.selector.style");
(0, theme_1.addStyles)(department_selector_style_1.Style);
var DepartmentSelector = /** @class */ (function (_super) {
    tslib_1.__extends(DepartmentSelector, _super);
    function DepartmentSelector() {
        var _this = _super.call(this) || this;
        _this.modal = new DepartmentSelectorModal({
            title: index_2.T.DEPARTMENT_SELECTOR_TITLE,
            confirm: index_2.T.DEPARTMENT_SELECTOR_ACCEPT,
            success: { key: index_2.T.DEPARTMENT_SELECTOR_SUCCESS }
        });
        return _this;
    }
    Object.defineProperty(DepartmentSelector.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (index_3.Services.Department.current == null) {
                return null;
            }
            var oneDepartment = index_3.Services.Department.departments.length < 2;
            var isDepartmentDisabled = this.modal.isDepartmentDisabled(index_3.Services.Department.current);
            var departmentName = isDepartmentDisabled ? "".concat(index_3.Services.Department.current.displayName, " (").concat((0, index_2.Translate)(index_2.T.DEPARTMENT_SELECTOR_DISABLED), ")") : index_3.Services.Department.current.displayName;
            var departmentClass = isDepartmentDisabled ? "".concat(department_selector_style_1.CSS.department, " ").concat(department_selector_style_1.CSS.departmentDisabled) : department_selector_style_1.CSS.department;
            return (0, mithril_1.m)('div', { className: department_selector_style_1.CSS.container }, [
                (0, mithril_1.m)('button', { className: "mdl-button ".concat(department_selector_style_1.CSS.btn), disabled: oneDepartment, onclick: function () { return _this.openModal(); } }, [
                    index_1.Icon.view(icons_1.MaterialIcon.DEPARTMENT, { className: department_selector_style_1.CSS.icon }),
                    (0, mithril_1.m)('span', { className: departmentClass }, departmentName)
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    DepartmentSelector.prototype.openModal = function () {
        this.modal.open();
    };
    return DepartmentSelector;
}(mithril_component_1.IMithrilComponent));
exports.DepartmentSelector = DepartmentSelector;
var DepartmentSelectorModal = /** @class */ (function (_super) {
    tslib_1.__extends(DepartmentSelectorModal, _super);
    function DepartmentSelectorModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.states = mobx_1.observable.array([], { deep: false });
        return _this;
    }
    DepartmentSelectorModal.prototype.open = function () {
        _super.prototype.open.call(this);
        this.states.replace(this.getStates());
    };
    DepartmentSelectorModal.prototype.getStates = function () {
        var states = [];
        var radioGroup = 'department-select';
        var currentDepartmentId = index_3.Services.Department.current.objectId;
        for (var _i = 0, _a = index_3.Services.Department.departments; _i < _a.length; _i++) {
            var department = _a[_i];
            var isCurrentDepartment = department.objectId === currentDepartmentId;
            var isDepartmentDisabled = this.isDepartmentDisabled(department);
            var departmentNameCurrent = isCurrentDepartment ? "".concat(department.displayName, " (").concat((0, index_2.Translate)(index_2.T.DEPARTMENT_SELECTOR_CURRENT), ")") : department.displayName;
            var departmentName = isDepartmentDisabled ? "".concat(departmentNameCurrent, " (").concat((0, index_2.Translate)(index_2.T.DEPARTMENT_SELECTOR_DISABLED), ")") : departmentNameCurrent;
            var state = new radio_input_state_1.RadioInputState(departmentName, radioGroup);
            state.id = department.objectId;
            if (isCurrentDepartment) {
                state.setValue(true);
            }
            if (isDepartmentDisabled) {
                state.setDisabled(true);
            }
            states.push(state);
        }
        return states;
    };
    Object.defineProperty(DepartmentSelectorModal.prototype, "nodes", {
        get: function () {
            var children = [];
            for (var _i = 0, _a = this.states; _i < _a.length; _i++) {
                var state = _a[_i];
                children.push(radio_input_1.RadioInput.view(state));
            }
            return (0, mithril_1.m)('div', {
                className: department_selector_style_1.CSS.departmentOptions
            }, children);
        },
        enumerable: false,
        configurable: true
    });
    DepartmentSelectorModal.prototype.submit = function () {
        var departmentId = null;
        for (var _i = 0, _a = this.states; _i < _a.length; _i++) {
            var state = _a[_i];
            if (state.value) {
                departmentId = state.id;
                break;
            }
        }
        if (departmentId == null) {
            throw new Error('No department selected');
        }
        return index_3.Services.UserSettings.setDepartment(departmentId).then(function () {
            // Redirect to home page if current page is not yet implemented in client-ui
            if (!index_3.Services.Route.supportDepartmentChange()) {
                index_3.Services.Route.go(page_1.IkePageName.map);
            }
        });
    };
    DepartmentSelectorModal.prototype.isDepartmentDisabled = function (department) {
        if (department.disableAt && Date.parse(department.disableAt) < Date.now()) {
            return true;
        }
        return false;
    };
    tslib_1.__decorate([
        mobx_1.action
    ], DepartmentSelectorModal.prototype, "open", null);
    return DepartmentSelectorModal;
}(modal_form_component_1.ModalFormComponent));
exports.DepartmentSelectorModal = DepartmentSelectorModal;
//# sourceMappingURL=department.selector.js.map